import { application } from "./application"

import NavController from "./nav_controller"
import RevealController from "./reveal_controller"
import ForDoctorsController from "./for_doctors_controller"
import ContactFormController from "./contact_form_controller"
import ChipGroupController from "./chip_group_controller"
import FileDropController from "./file_drop_controller"
import GalleryController from "./gallery_controller"
import CookiesController from "./cookies_controller"
import CookiesOpenerController from "./cookies_opener_controller"
import DoctorAutocompleteController from "./doctor_autocomplete_controller"
import WhatsappShareController from "./whatsapp_share_controller"
import AuthorMemoryController from "./author_memory_controller"
import DocumentsFilterController from "./documents_filter_controller"
import BeforeAfterController from "./before_after_controller"
import BulkSelectController from "./bulk_select_controller"
import GalleryFormController from "./gallery_form_controller"
import ProcessFlowController from "./process_flow_controller"
import ConfirmController from "./confirm_controller"

application.register("nav", NavController)
application.register("reveal", RevealController)
application.register("for-doctors", ForDoctorsController)
application.register("contact-form", ContactFormController)
application.register("chip-group", ChipGroupController)
application.register("file-drop", FileDropController)
application.register("gallery", GalleryController)
application.register("cookies", CookiesController)
application.register("cookies-opener", CookiesOpenerController)
application.register("doctor-autocomplete", DoctorAutocompleteController)
application.register("whatsapp-share", WhatsappShareController)
application.register("author-memory", AuthorMemoryController)
application.register("documents-filter", DocumentsFilterController)
application.register("before-after", BeforeAfterController)
application.register("bulk-select", BulkSelectController)
application.register("gallery-form", GalleryFormController)
application.register("process-flow", ProcessFlowController)
application.register("confirm", ConfirmController)
